import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const CalendarGift = (props) => {
  const data = useStaticQuery(graphql`
    query {
      calendarGift: file(
        relativePath: {
          eq: "components/pages/HiringPage/Sections/GallerySection/images/calendar-gift.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 618, maxHeight: 445, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.calendarGift.childImageSharp.fluid} {...props} />
}

export default CalendarGift
